__turbopack_context__.v({
  "container": "ReferenceTable-module__wh40Pa__container",
  "copyCell": "ReferenceTable-module__wh40Pa__copyCell",
  "copyIcon": "ReferenceTable-module__wh40Pa__copyIcon",
  "counter": "ReferenceTable-module__wh40Pa__counter",
  "empty": "ReferenceTable-module__wh40Pa__empty",
  "pageBtn": "ReferenceTable-module__wh40Pa__pageBtn",
  "pageInfo": "ReferenceTable-module__wh40Pa__pageInfo",
  "pagination": "ReferenceTable-module__wh40Pa__pagination",
  "searchInput": "ReferenceTable-module__wh40Pa__searchInput",
  "sortArrow": "ReferenceTable-module__wh40Pa__sortArrow",
  "sortable": "ReferenceTable-module__wh40Pa__sortable",
  "table": "ReferenceTable-module__wh40Pa__table",
  "tableWrapper": "ReferenceTable-module__wh40Pa__tableWrapper",
  "toolbar": "ReferenceTable-module__wh40Pa__toolbar",
});
